import Card from "../../Card/card";
import AsyncAutoComplete from "../../MUI_components/AutoComplete/asynchronousAutoComplete";
import AsyncAutoCompleteEnter from "../../MUI_components/AutoComplete/asynchronousAutoCompleteEnter";

import FormControl from "../../MUI_components/FormControl/fomikFormControl";
import Dialog from "../../MUI_components/Dialog-Box/dialog";
import BasicDialog from "../../MUI_components/Dialog-Box/basicDialog";
import ItemMasterService from "../../../Service/Item-master/itemMaster.service";
import AddCustomer from "./addCustomerFromPos";
import { Field, Form, Formik, FieldArray } from "formik";

import { currency } from "../../MUI_components/currencyFormatterTag";

import SalesOrder from "../../Store/SalesOrder/addSalesOrder";
import { NumFormat } from "../../MUI_components/currencyFormat";
import VehicleService from "../../../Service/Vehicle-Master/vehicle.service";

import { useHotkeys } from "react-hotkeys-hook";
import { useReactToPrint } from "react-to-print";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";

import Service from "../../../Service/Invoice/invoice.service";
import ServiceAutoCare from "../../../Service/Invoice/invoiceAutoCare.service";

import { useDispatch, useSelector } from "react-redux";
import { openSnackbar } from "../../../Redux/Actions/snackbarActions";
import { getLastInsertInvoice } from "../../../Redux/Actions/lastinsertInvoice";

//Change the print depending on Dot Matrix or POS
import Print from "./Receipt/AutoCare/DotMatrix/dotmatrix_Template_1";
//import Print from "./Receipt/returnNoteReceipt";

import Loading from "../../MUI_components/loading";
import Payments from "./Payments/morePayments";
import RecentSales from "./recentSales";
import { pageStyle } from "../../Print/printPagesStyles";
import {
  AssignmentReturnOutlined,
  AttachMoney,
  Delete,
  DeleteOutlineOutlined,
  GroupAddOutlined,
  LocalOfferOutlined,
  ReceiptOutlined,
  SaveOutlined,
} from "@mui/icons-material";
import {
  Button,
  Grid,
  TextField,
  CircularProgress,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import React, { useState } from "react";
import { Box } from "@mui/system";
import SalesReturn from "./SalesReturn/salesReturn";
import { PAYMENT_STATUS_CODE } from "Components/Constants/PaymentStatusCode";
import { PAYMENT_TYPE } from "Components/Constants/PaymentType";
import { COLUMNS_NAME } from "Components/Constants/ColumnsNames";
import servicepackService from "Service/Vehicle-Master/servicepack.service";
import customerService from "Service/Customer/customer.service";
import { CUSTOMER_CONST } from "Components/Constants/CustomerContsnt";



const SalesForAutoCare = () => {
  const dispatch = useDispatch();
  const paymentTypes = useSelector((state) => state.paymentType);
  const stockLocations = useSelector((state) => state.location);
  const [lastThreeInvoice, setLastThreeInvoice] = useState([]);
  const [disabledForSingle, setDisabledForSingle] = useState(false);
  const defaultLocationSelected = useSelector((state) => state.defaultLocation);
  const [desCount = 0, desCountTotal = 20] = React.useState(0);

  const [pageStatus, setPageStatus] = useState(
    {
      adding: true,
      recalled: false,
      editable: false
    }
  );
  const [printType, setPrintType] = useState('POS');

  const fetchRecentInvoice = async (code) => {
    try {
      let response = await Service.getLastThree(code);
      setLastThreeInvoice(response);
    } catch (e) {
      dispatch(openSnackbar(true, "error", e));
    }
  };

  const handleInput = (e) => {
    const input = e.target.value;
    if (input !== '' && Number(input) < 0) {
      e.target.value = '0';
    }
  };

  const formValid = React.createRef();
  const computerReceiptPrintComponent = React.useRef(null);
  const billReceiptPrintComponent = React.useRef(null);

  const saveBill = React.createRef();
  const addingProduct = React.createRef();

  //Equal to stock History
  const initInvoiceData = {
    invoiceCode: "",
    itemMaster: null,
    quantity: 1,
    discountAmount: 0,
    discountPercentage: 0,
    discountTotal: 0, //Line Discount Percentage + Line Discount Amount
    subTotalAmount: 0,//Before Discount 
    totalAmount: 0,//After Discount. This will be stored in database. Calculations on front end not working. 
    warrantyDueDate: "",
  };
  const initInvoice = {
    payment: {
      amount: "",
      paidStatus: 0,
      paymentType: "",
      remarks: "",
      bankDeposit: {
        date: "",
        refNumber: "",
      },
      chequePayment: {
        date: "",
        bank: "",
        chequeNumber: "",
      },
      cardPayment: {
        refNumber: "",
        cardNumber: "",
      },
    },
    customer: null,
    invoiceExt: {
      odoReading: 0,
      nextServiceKm: 0,
      nextServiceDate: "",
      vehicleMaster: null,
    },
    modeOfPayments: [],
    servicePack: "",
    salesQuotation: null,
    discountAmount: 0,// discount amount is applicable for the amount which is after the line discount
    discountPercentage: 0,// discount percentage is applicable for the amount which is after the lie discount
    discountTotal: 0,// Entire Line + Bill Discount Percentage + Bill discount amount
    subTotalAmount: 0,//Before Discount 
    billDiscount: 0, // total bill level discount (discountAmount + discountPercentage)
    totalAmount: 0,//After Discount 
    date: "",
    receivedAmount: 0,//The total received amount during the invoice cash payment
    stockHistories: [],
    paidStatus: PAYMENT_STATUS_CODE.PAYMENT_NOT_DONE,
    prints: 0,
    paidAmount: 0,// This is the total paid amount to be store in Payment Receipt and invoice Paid Amount

  };
  // const [alignment, setAlignment] = useState("barcode");

  const [open, setOpen] = useState({
    addCustomer: false,
    discount: false,
    return: false,
    salesOrder: false,
    payment: false,
    cashPay: false,
    creditPrint: false
  });

  const [invoiceDataValue, setInvoiceDataValue] = useState(initInvoiceData);
  const [submittedData, setSubmittedData] = useState();

  const [invoiceValue, setInvoiceValue] = useState(initInvoice);
  const [isLoading, setIsLoading] = useState(false);

  // <--------------------------- shot-cut keys -------------------------->
  useHotkeys("F2", () => setOpen({ ...open, discount: true }), {
    enableOnTags: ["INPUT"],
  });
  useHotkeys("F4", () => setOpen({ ...open, return: true }), {
    enableOnTags: ["INPUT"],
  });
  // useHotkeys("Alt + R", () => (handlePrint()), {
  //   enableOnTags: ["INPUT"],
  // });
  useHotkeys("Alt + c", () => setOpen({ ...open, addCustomer: true }), {
    enableOnTags: ["INPUT"],
  });
  useHotkeys("Alt + o", () => setOpen({ ...open, salesOrder: true }), {
    enableOnTags: ["INPUT"],
  });
  useHotkeys("F8", () => addingProduct.current.click(), {
    enableOnTags: ["INPUT"],
  });
  useHotkeys("F1", (e) => {
    e.preventDefault();
    setOpen({ ...open, cashPay: true });
  },
    {
      enableOnTags: ["INPUT"],
    }
  );
  useHotkeys(
    "Ctrl + s",
    (e) => {
      e.preventDefault();
      saveBill.current.click();
    },
    {
      enableOnTags: ["INPUT"],
    }
  );
  useHotkeys("F9", () => setOpen({ ...open, payment: true }), {
    enableOnTags: ["INPUT"],
  });
  // <--------------------------- shot-cut keys -------------------------->

  const handleInvoiceDataChange = (e) => {
    const { name } = e.target;
    const { value } = e.target;
    setInvoiceDataValue({ ...invoiceDataValue, [name]: value });
  };

  const handleAddInvoiceData = (invoiceDataValue, push, noValid) => {
    if (formValid.current.reportValidity() && invoiceDataValue.itemMaster) {
      let stockHistory = {
        ...invoiceDataValue.itemMaster,
        quantity: invoiceDataValue.quantity,
        itemCode: invoiceDataValue.itemMaster.code,
        discountAmount: 0,
        discountPercentage: 0,
        subTotalAmount: (invoiceDataValue.quantity * invoiceDataValue.itemMaster.retailPrice),
      }

      push(stockHistory);
      setInvoiceDataValue(initInvoiceData);
    } else if (noValid) {
      let stockHistory = {
        ...invoiceDataValue.itemMaster,
        quantity: invoiceDataValue.quantity,
        itemCode: invoiceDataValue.itemMaster.code,
        discountAmount: 0,
        discountPercentage: 0,
        subTotalAmount: (invoiceDataValue.quantity * invoiceDataValue.itemMaster.retailPrice),
      }
      push(stockHistory);
      setInvoiceDataValue(initInvoiceData);
    }
  };
  //Stock History Level
  const handleLineTotal = (qty, price, discountPer, discountAmount) => {
    let totalAmount = qty * price;
    discountAmount = discountAmount * qty;
    let lineTotalAmount = totalAmount - totalAmount * (discountPer / 100) - discountAmount;
    return lineTotalAmount;
  };


  const recallPrevInvoice = async (code) => {
    setPageStatus(
      {
        ...pageStatus,
        adding: false,
        editable: false,
        recalled: true
      }
    );
    try {
      const res = await ServiceAutoCare.getPrevInvoice(code);
      setInvoiceValue({
        ...res,
        payment: {
          amount: "",
          paidStatus: PAYMENT_STATUS_CODE.PAYMENT_NOT_DONE,
          paymentType: "",
          bankDeposit: {
            date: "",
            refNumber: "",
          },
          chequePayment: {
            date: "",
            bank: "",
            chequeNumber: "",
          },
          cardPayment: {
            refNumber: "",
            cardNumber: "",
          },
        },
        modeOfPayments: [],
      });
      setSubmittedData(res);

    } catch (e) {
      dispatch(openSnackbar(true, "error", e));
    }
    setIsLoading(false);
  };

  // const handlePrint = useReactToPrint({

  //   content: () => printType == 'POS' ? billReceiptPrintComponent.current : computerReceiptPrintComponent.current,
  //   onAfterPrint: () => {
  //     setInvoiceValue(initInvoice);
  //     setOpen({
  //       ...open,
  //       cashPay: false,
  //       payment: false,
  //       creditPrint: false
  //     });
  //     setPageStatus({
  //       ...pageStatus,
  //       editable: false,
  //       recalled: false,
  //       adding: true
  //     });
  //     dispatch(getLastInsertInvoice({ code: null, date: null }));
  //     fetchRecentInvoice();
  //   },
  //   pageStyle: pageStyle.receipt,
  // });

  const handlePrintPOS = useReactToPrint({

    content: () => billReceiptPrintComponent.current,
    onAfterPrint: () => {
      setInvoiceValue(initInvoice);
      setOpen({ ...open, cashPay: false, payment: false });
      setPageStatus({
        ...pageStatus,
        editable: false,
        recalled: false,
        adding: true
      });
      dispatch(getLastInsertInvoice({ code: null, date: null }));
      fetchRecentInvoice();
    },
    pageStyle: pageStyle.receipt,
  });
  const handlePrintDotMatrix = useReactToPrint({
    content: () => computerReceiptPrintComponent.current,
    onAfterPrint: () => {
      setInvoiceValue(initInvoice);
      setOpen({ ...open, cashPay: false, payment: false });
      setPageStatus({
        ...pageStatus,
        editable: false,
        recalled: false,
        adding: true
      });
      dispatch(getLastInsertInvoice({ code: null, date: null }));
      fetchRecentInvoice();
    },
    pageStyle: pageStyle.a4,
  });
  const handleSubmit = async (values, onSubmitProps) => {
    try {
      let res;
      if (invoiceValue.code) {
        res = await ServiceAutoCare.edit(values, invoiceValue.code);
      } else {
        res = await ServiceAutoCare.create(values);
      }
      values.code = res.code;
      setSubmittedData(values)

      dispatch(
        openSnackbar(
          true,
          "success",
          `#${res.code} Invoice ${invoiceValue.code ? `updated` : `added`
          } successfully`
        )
      );
      // dispatch(getLastInsertInvoice(res));

      if( printType == 'POS') {
        handlePrintPOS();
        
      }else{
        handlePrintDotMatrix();
      }
      setOpen({ ...open, cashPay: false, payment: false,creditPrint:false });

      onSubmitProps.resetForm();
    } catch (e) {
      dispatch(openSnackbar(true, "error", e));
    }
  };
  const CustomInput = (props) => {
    return (
      <input
        type="number"
        style={{
          fontSize: 12,
          width: props.width ? props.width : 50,
          maxWidth: 200,
        }}
        step="any"
        {...props}
        className="custom-input"
      />
    );
  };

  return (
    // <Card title="Invoice">

    <Formik
      initialValues={invoiceValue}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {(props) => {
        const { setFieldValue, values, isSubmitting } = props;




        //Invoice Level Calculations

        const subTotalAmount = values.stockHistories
          .map(({ quantity, discountPercentage, discountAmount, retailPrice }) =>
            handleLineTotal(
              quantity,
              retailPrice,
              discountPercentage,
              discountAmount
            )
          )
          .reduce((sum, i) => sum + i, 0);

        const billDiscount =
          subTotalAmount * (values.discountPercentage / 100) +
          parseFloat(values.discountAmount ? values.discountAmount : 0);

        const totalLineDiscount = (values.stockHistories
          .map(({ quantity, retailPrice }) =>
            quantity *
            retailPrice
          )
          .reduce((sum, i) => sum + i, 0)) - subTotalAmount;

        const discountTotal = billDiscount + totalLineDiscount;

        const totalAmount = values.stockHistories
          .map(({ quantity, discountPercentage, discountAmount, retailPrice }) =>
            handleLineTotal(
              quantity,
              retailPrice,
              discountPercentage,
              discountAmount
            )
          )
          .reduce((sum, i) => sum + i, 0) - billDiscount;


          const checkValidInvoice = () => { 
            if (values.customer) {
              if(values.customer?.code == CUSTOMER_CONST.CASH_CUSTOMER) {
                alert(`"CASH": Customer CREDIT Not Applicable `);
                return false; 
              }else
              return true;
            } else {
              alert("Please assign the customer");// hear check assing cash customer
              return false;
            }
          };

        const handleCashPay = () => {
          if (
            values.receivedAmount >= totalAmount &&
            cashPaymentValidity()
          ) {
            let cashPaymentMode = {
              amount: totalAmount,
              paidStatus: PAYMENT_STATUS_CODE.PAYMENT_COMPLETED,
              paymentType: paymentTypes.filter(
                (paymentType) => paymentType.name === PAYMENT_TYPE.CASH_PAYMENT
              )[0]["code"],
              remarks: "Cash from Invoice"

            }
            let mode = []
            mode.push(cashPaymentMode);



            setInvoiceValue({
              ...values,
              paidStatus: PAYMENT_STATUS_CODE.PAYMENT_COMPLETED,
              payment: {
                ...values.payment,
                paidStatus: PAYMENT_STATUS_CODE.PAYMENT_COMPLETED,
                paidAmount: totalAmount,
                paymentType: paymentTypes.filter(
                  (paymentType) => paymentType.name === PAYMENT_TYPE.CASH_PAYMENT
                )[0]["code"],
                remarks: "Cash from Invoice"

              },
              modeOfPayments: { ...mode },
              discountTotal: discountTotal,
              subTotalAmount: subTotalAmount,
              totalAmount: totalAmount,
              paidAmount: totalAmount,
              billDiscount: billDiscount
            })

            setFieldValue("totalAmount", totalAmount);

            props.handleSubmit();
          }
        };
        const handleMorePayments = () => {
          if (checkValidInvoice()) {
            setFieldValue("discountTotal", discountTotal);
            setFieldValue("subTotalAmount", subTotalAmount);
            setFieldValue("totalAmount", totalAmount);
            setFieldValue("billDiscount", billDiscount);

            const paidTotal = values.modeOfPayments
              .map(({ amount }) => amount)
              .reduce((sum, i) => sum + i, 0);
            setFieldValue("paidAmount", paidTotal);
            setFieldValue("receivedAmount", paidTotal);

            if (totalAmount <= paidTotal) {
              setFieldValue("paidStatus", PAYMENT_STATUS_CODE.PAYMENT_COMPLETED);
            } else if (totalAmount > paidTotal) {
              setFieldValue("paidStatus", PAYMENT_STATUS_CODE.PAYMENT_PARTIAL);
            }//0=not done

            props.handleSubmit();
          }
        };
        const handleCreditBill = () => {
          if ( values.stockHistories.length) {
            setFieldValue("discountTotal", discountTotal);

            setFieldValue("subTotalAmount", subTotalAmount);
            setFieldValue("totalAmount", totalAmount);
            setFieldValue("paidAmount", 0);
            //setFieldValue("payment.paymentType", null);
            setFieldValue("billDiscount", billDiscount);
            setFieldValue("paidStatus", PAYMENT_STATUS_CODE.PAYMENT_NOT_DONE);

            props.handleSubmit();
          }
        };

        const cashPaymentValidity = () => {
          if (
            // values.paidAmount >= values.totalAmount &&
            values.receivedAmount >= values.totalAmount &&

            values.stockHistories.length
          )
            return true;
          else return false;
        };

        const handleFocus = event => {
          event.preventDefault();
          const { target } = event;
          target.focus();
          target.type = 'text';
          target.setSelectionRange(0, target.value.length);
          target.type = 'number';
        }


        return (
          <Form ref={formValid} autoComplete="off">
            <Grid container spacing={3}>
              {isSubmitting || isLoading ? (
                <Grid item md={8} lg={8} sm={12} xs={12}>
                  <Loading
                    text={isLoading ? "Please wait... " : "Saving invoice..."}
                  />
                </Grid>
              ) : (
                <Grid item md={8} lg={8} sm={12} xs={12}>
                  <Card
                    title={`Invoice ${invoiceValue.code ? ` - ` + invoiceValue.code : ``
                      }`}
                    showTime
                    style={{ height: "90vh" }}
                  >
                    <div style={{ padding: 10, height: "100%" }}>
                      <FieldArray name="stockHistories">
                        {(fieldArrayProps) => {
                          const { push, remove } = fieldArrayProps;

                          return (
                            <>
                              {!pageStatus.recalled && (
                                <Paper style={{ padding: 5, margin: 5 }}>
                                  <table
                                    className="fullWidth mb"
                                    onKeyPress={(e) => {
                                      e.key === "Enter" &&
                                        handleAddInvoiceData(
                                          invoiceDataValue,
                                          push
                                        );
                                    }}
                                  >
                                    <tbody>
                                      <tr>
                                        <td className="col-4">

                                          <AsyncAutoComplete
                                            inputProps={{
                                              size: "small",
                                              placeholder: "Customer",
                                              autoFocus: true,
                                            }}
                                            variant="filled"
                                            value={values.customer}
                                            onChange={(e, newValue) => {
                                              setFieldValue("customer", newValue);
                                            }}
                                            Service={customerService.search}
                                            getOptionLabel={(option) =>
                                              option.firstName + " - " + option.secondName + " - " + option.customCode + 
                                              " - " +
                                              option.phone1 
                                            }
                                          />
                                        </td>
                                        <td className="col-5">
                                          <AsyncAutoComplete
                                            inputProps={{
                                              size: "small",
                                              placeholder: "Vehicle",
                                              autoFocus: true,
                                            }}
                                            variant="filled"
                                            value={values.invoiceExt.vehicleMaster}
                                            onChange={(e, newValue) => {
                                              setFieldValue(
                                                "invoiceExt.vehicleMaster",
                                                newValue
                                              );
                                              if (newValue) {
                                                setFieldValue(
                                                  "customer",
                                                  newValue.customer
                                                );
                                              }

                                            }}
                                            //disabled={pageStatus.editable}
                                            Service={VehicleService.search}
                                            getOptionLabel={(option) =>
                                              option.description +
                                              " - " +
                                              option.vehicleNumber
                                            }
                                          />
                                        </td>
                                        <td className="col-3" colSpan={2}>
                                          <Field
                                            as={TextField}
                                            type="number"
                                            size="small"
                                            name="invoiceExt.odoReading"
                                            fullWidth
                                            variant="filled"
                                            inputProps={{
                                              min: 0,
                                              placeholder: "ODO Reading",
                                            }}
                                          />
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="col-9" colSpan={2}>
                                          <AsyncAutoCompleteEnter
                                            fullWidth
                                            inputProps={{
                                              placeholder: `Select Product`,
                                              size: "small",
                                              autoFocus: true,

                                              // ref: addingProduct,
                                            }}
                                            variant="filled"
                                            Service={ItemMasterService.posSearch}
                                            value={invoiceDataValue.itemMaster}
                                            getOptionLabel={(option) =>
                                              option.itemMaster.name +
                                              " | " +
                                              option.code +
                                              " | " +
                                              option.itemMaster.barcode +
                                              " | " +
                                              option.itemMaster.description
                                            }
                                            renderOption={(props, option) => (
                                              <Box {...props}>
                                                <div
                                                  className="flex"
                                                  style={{
                                                    width: "100%",
                                                    padding: "5px 10px",
                                                  }}
                                                >
                                                  <div className="col-6 opt-left">
                                                    <p
                                                      className="color-green"
                                                      style={{
                                                        fontSize: 15,
                                                      }}
                                                    >
                                                      {option.itemMaster.name}
                                                    </p>
                                                    <p>
                                                      Barcode: {option.itemMaster.barcode}
                                                    </p>
                                                    <p>{option.description}</p>
                                                  </div>
                                                  <div className="col-6  opt-right">
                                                    <p className="color-red">
                                                      {` WP. ${option.wholesalePrice} | RP. ${option.retailPrice}`}
                                                    </p>
                                                    <p className="color-green">
                                                      {`Quantity : ${option.remainingQuantity}`}
                                                    </p>
                                                    <p className="color-blue">
                                                      {`Location : ${stockLocations.filter(
                                                        (location) => location.code === option.stockLocationCode
                                                      )[0]["name"]}`}
                                                    </p>
                                                    {option.itemMaster.stocks
                                                      .filter(e => e.stockLocationCode !== defaultLocationSelected.location.code
                                                        && e.remainingQuantity > 0
                                                      )
                                                      .map((stock, index) => (
                                                        <><p className="color-dark-green ">
                                                          {` ${stockLocations.filter(
                                                            (location) => location.code == stock.stockLocationCode
                                                          )[0]["name"]} | Q : ${stock.remainingQuantity} | Rs. ${stock.retailPrice} `}
                                                        </p>
                                                        </>
                                                      ))}
                                                  </div>
                                                </div>
                                              </Box>
                                            )}
                                            onChange={(e, newValue) => {
                                              setInvoiceDataValue({
                                                ...invoiceDataValue,
                                                itemMaster: newValue,
                                              });
                                            }}

                                          />
                                        </td>
                                        <td className="col-2">
                                          <TextField
                                            type="number"
                                            size="small"
                                            name="quantity"
                                            value={invoiceDataValue.quantity}
                                            onChange={handleInvoiceDataChange}
                                            variant="filled"
                                            inputProps={{
                                              placeholder: "Quantity",
                                            }}
                                            required
                                            onInput={handleInput}

                                          />
                                        </td>
                                        <td className="col-1">
                                          <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={(e) => {
                                              handleAddInvoiceData(
                                                invoiceDataValue,
                                                push
                                              );
                                            }}
                                          >
                                            Add
                                          </Button>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td colSpan={3} className="col-6">
                                          <AsyncAutoComplete
                                            inputProps={{
                                              size: "small",
                                              placeholder: "Service Packages",
                                            }}
                                            disableClearable
                                            variant="filled"
                                            value={values.servicePack}
                                            onChange={(e, newValue) => {
                                              setFieldValue("servicePack", newValue);
                                            }}
                                            Service={servicepackService.search}
                                            getOptionLabel={(option) =>
                                              option.code +
                                              " - " +
                                              option.name
                                            }
                                          />
                                        </td>
                                        <td className="col-1">
                                          <span
                                            className="btn-info button"
                                            variant="contained"
                                            color="default"
                                            onClick={() => {
                                              values.servicePack &&
                                                values.servicePack.servicePackageDatas.map(
                                                  (row) =>
                                                    handleAddInvoiceData(
                                                      {
                                                        ...invoiceDataValue,
                                                        itemMaster: row.itemMaster,
                                                      },
                                                      push,
                                                      true
                                                    )
                                                );
                                            }}
                                          >
                                            Load
                                          </span>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>

                                </Paper>

                              )}


                              <TableContainer>
                                <Table size="small" aria-label="spanning table">
                                  <TableHead
                                    style={{ backgroundColor: "#cacaca50" }}
                                  >
                                    <TableRow>
                                      <TableCell align="center" colSpan={7}>
                                        Details
                                      </TableCell>
                                      <TableCell align="right">Price</TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell
                                        style={{ padding: "0 5px" }}
                                      ></TableCell>
                                      <TableCell style={{ padding: "0 5px" }}>
                                        #
                                      </TableCell>
                                      <TableCell>{COLUMNS_NAME.DESCRIPTION}</TableCell>
                                      <TableCell align="right">{COLUMNS_NAME.QUANTITY}</TableCell>
                                      <TableCell align="right">
                                        {COLUMNS_NAME.UNIT_PRICE}
                                      </TableCell>
                                      <TableCell align="right">{COLUMNS_NAME.DISCOUNT_PERCENTAGE}</TableCell>
                                      <TableCell align="right">
                                        {COLUMNS_NAME.DISCOUNT_AMOUNT}
                                      </TableCell>
                                      <TableCell align="right">{COLUMNS_NAME.TOTAL}</TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {values.stockHistories.map((row, index) => (
                                      <TableRow key={index}>
                                        <TableCell style={{ padding: "0 5px" }}>
                                          {pageStatus.adding && (
                                            <Delete
                                              color="secondary"
                                              style={{
                                                fontSize: 18,
                                                cursor: "pointer",
                                              }}
                                              onClick={() => {
                                                if (
                                                  window.confirm(
                                                    "Are you sure want to delete this?"
                                                  )
                                                )
                                                  remove(index);
                                              }}
                                            />
                                          )}

                                        </TableCell>
                                        <TableCell style={{ padding: "0 5px" }}>
                                          {index + 1}
                                        </TableCell>
                                        <TableCell style={{ fontSize: 11.5, wordBreak: "break-word" }}>
                                       { row && (row.name ? row.name : (row.itemMaster && row.itemMaster.name) ? row.itemMaster.name + " - " + (row.itemMaster.description || '') : '')}
                                        </TableCell>
                                        <TableCell align="right">
                                          <Field
                                            min="0"
                                            as={CustomInput}
                                            disabled={pageStatus.recalled}
                                            name={`stockHistories[${index}].quantity`}
                                          />
                                        </TableCell>
                                        <TableCell align="right">
                                          <Field
                                            width="80"
                                            min="1"
                                            as={CustomInput}
                                            disabled={pageStatus.recalled}
                                            name={`stockHistories[${index}].retailPrice`}
                                          />
                                        </TableCell>
                                        <TableCell align="right">
                                          <Field
                                            onFocus={handleFocus}
                                            min="0"
                                            as={CustomInput}
                                            disabled={pageStatus.recalled}
                                            name={`stockHistories[${index}].discountPercentage`}
                                          />
                                        </TableCell>
                                        <TableCell align="right">
                                          <Field
                                            onFocus={handleFocus}
                                            min="0"
                                            disabled={pageStatus.recalled}
                                            as={CustomInput}
                                            name={`stockHistories[${index}].discountAmount`}
                                          />
                                        </TableCell>
                                        <TableCell align="right">
                                          {currency(
                                            handleLineTotal(
                                              row.quantity,
                                              row.retailPrice,
                                              row.discountPercentage,
                                              row.discountAmount
                                            )
                                          )}
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                  <TableHead>
                                    {values.stockHistories.length === 0 ? (
                                      <TableRow>
                                        <TableCell align="center" colSpan={8}>
                                          No Data
                                        </TableCell>
                                      </TableRow>
                                    ) : (
                                      <>
                                        <TableRow>
                                          <TableCell colSpan={4} rowSpan={3} />
                                          <TableCell colSpan={3}>
                                            {COLUMNS_NAME.SUB_TOTAL}
                                          </TableCell>
                                          <TableCell align="right">
                                            {currency(subTotalAmount)}
                                          </TableCell>
                                        </TableRow>
                                        <TableRow>
                                          <TableCell>Bill Discount</TableCell>
                                          <TableCell align="right">{`${values.discountPercentage} %`}</TableCell>
                                          <TableCell align="right">{` ${currency(values.discountAmount)} `}</TableCell>
                                          <TableCell align="right">
                                            {currency(billDiscount)}
                                          </TableCell>
                                        </TableRow>
                                        <TableRow
                                          style={{
                                            backgroundColor: "#cacaca50",
                                          }}
                                        >
                                          <TableCell colSpan={3}>
                                            <h3>{COLUMNS_NAME.LAST_TOTAL}</h3>
                                          </TableCell>
                                          <TableCell align="right">
                                            <h3>
                                              {currency(
                                                totalAmount
                                              )}
                                            </h3>
                                          </TableCell>
                                        </TableRow>
                                      </>
                                    )}
                                  </TableHead>
                                </Table>
                              </TableContainer>
                            </>
                          );
                        }}
                      </FieldArray>
                    </div>
                  </Card>
                </Grid>
              )}
              <Grid item md={4} lg={4} sm={12} xs={12}>
                <Paper style={{ padding: 5, margin: 5 }}>
                  {!pageStatus.recalled ? (
                    <>
                      <Grid container spacing={1} marginBottom={1}>
                        <Grid item xs={4}>
                          {!invoiceValue.code &&
                            <span
                              type="button"
                              className="btn-success button"
                              onClick={() =>
                                setOpen({ ...open, cashPay: true })
                              }
                            >
                              <AttachMoney />
                              Cash pay
                              <span>[ F1 ]</span>
                            </span>
                          }
                          <BasicDialog
                            title="Cash Payment"
                            open={open.cashPay}
                            setOpen={(val) => {
                              setOpen({ ...open, cashPay: val });
                            }}
                            onKeyPress={(e) => {
                              if (e.key === "Enter") {
                                handleCashPay();
                              }
                            }}
                          >
                            <div className="flex mb">
                              <TextField
                                variant="standard"
                                fullWidth
                                label="Bill Total"
                                disabled
                                value={currency(totalAmount)}
                              />
                            </div>
                            <div className="flex mb">
                              <FieldArray name="payment">
                                <FormControl
                                  control="currency"
                                  fullWidth
                                  variant="standard"
                                  label="Received Amount"
                                  autoFocus
                                  // onFocus={handleFocus}
                                  name="receivedAmount"
                                  className="mt"
                                  disabled={!values.stockHistories.length}
                                />
                              </FieldArray>
                            </div>
                            <div className="flex mb">
                              <TextField
                                variant="standard"
                                fullWidth
                                label="Balance"
                                disabled
                                value={currency(
                                  values.receivedAmount - totalAmount
                                    ? values.receivedAmount - totalAmount
                                    : 0
                                )}
                              />
                            </div>
                            <div className="flex">
                              {/* <button
                                type="button"
                                disabled={
                                  !cashPaymentValidity() || isSubmitting
                                }
                                onClick={() => {
                                  setDisabledForSingle(true);
                                  setPrintType('POS');
                                  handleCashPay();
                                  setDisabledForSingle(false);
                                }}
                                className="btn-success button"
                              >
                                pos bill
                                <span>
                                  {isSubmitting ? (
                                    <CircularProgress
                                      color="inherit"
                                      size={20}
                                    />
                                  ) : (
                                    "[ Enter ]"
                                  )}
                                </span>
                              </button> */}

                              <button
                                type="button"
                                disabled={
                                  !cashPaymentValidity() || isSubmitting
                                }
                                onClick={() => {
                                  setPrintType('DOT');
                                  handleCashPay();
                                }}
                                className="btn-success button"
                              >
                                    Print Bill                                
                                <span>
                                  {isSubmitting ? (
                                    <CircularProgress
                                      color="inherit"
                                      size={20}
                                    />
                                  ) : (
                                    ""
                                  )}
                                </span>
                              </button>

                            </div>
                            <div className="flex-end">
                              <Button
                                color="secondary"
                                onClick={() => {
                                  setFieldValue('receivedAmount', '');
                                  setOpen({ ...open, cashPay: false });
                                }}
                              >
                                Close
                              </Button>
                            </div>
                          </BasicDialog>

                        </Grid>
                        <Grid item xs={4}>
                          <span
                            type="button"
                            disabled={isSubmitting}
                            onClick={() =>
                              values.customer?.code == CUSTOMER_CONST.CASH_CUSTOMER ? alert(`"CASH": Customer Credit Bill Not Applicable`) :
                              setOpen({ ...open, creditPrint: true })
                            }
                            className="btn-info button"
                            ref={saveBill}
                          >
                            <SaveOutlined />
                            Credit
                            <span>[ Ctrl + s ]</span>
                          </span>
                          {/* Basic Dialog for when billing for credit bill */}
                          <BasicDialog
                            title="Credit Print"
                            open={open.creditPrint}
                            setOpen={(val) => {
                              setOpen({ ...open, cashPay: val });
                            }}
                            onKeyPress={(e) => {
                              if (e.key === "Enter") {
                                handleCreditBill();
                              }
                            }}
                            onClose={(e) => {

                            }}
                          >
                            <div className="flex mb">
                              <TextField
                                variant="standard"
                                fullWidth
                                label="Bill Total"
                                disabled
                                value={currency(totalAmount)}
                              />
                            </div>
                            <div className="flex">
                              {/* <button
                                type="button"
                                disabled={disabledForSingle}
                                onClick={() => {
                                  setDisabledForSingle(true);
                                  setPrintType('POS');
                                  handleCreditBill();
                                  setTimeout(() => {
                                    setDisabledForSingle(false);

                                  }, 5000);
                                }}
                                className="btn-success button"
                              >
                                pos bill
                                <span>
                                  {isSubmitting ? (
                                    <CircularProgress
                                      color="inherit"
                                      size={20}
                                    />
                                  ) : (
                                    "[ Enter ]"
                                  )}
                                </span>
                              </button> */}

                              <button
                                type="button"
                                disabled={
                                  isSubmitting || disabledForSingle
                                }
                                onClick={() => {
                                  setPrintType('DOT');
                                  handleCreditBill();
                                  setOpen({ ...open, creditPrint: false })

                                }}
                                className="btn-success button"
                              >
                                Print bill
                                <span>
                                  {isSubmitting ? (
                                    <CircularProgress
                                      color="inherit"
                                      size={20}
                                    />
                                  ) : (
                                    ""
                                  )}
                                </span>
                              </button>

                            </div>
                            <div className="flex-end">
                              <Button
                                color="secondary"
                                onClick={() =>
                                  setOpen({ ...open, creditPrint: false })
                                }
                              >
                                Close
                              </Button>
                            </div>
                          </BasicDialog>
                        </Grid>
                        <Grid item xs={4}>
                          <span
                            className="btn-danger button"
                            onClick={(e) => {
                              if (
                                window.confirm("Do you want to clear this?")
                              )
                                setInvoiceValue(initInvoice);
                              props.handleReset();
                            }}
                          >
                            <DeleteOutlineOutlined />
                            Clear
                            <span>[...]</span>
                          </span>
                        </Grid>
                      </Grid>
                      <Grid container spacing={1} marginBottom={1}>
                        <Grid item xs={4}>
                          <span
                            onClick={(e) => {
                              setOpen({ ...open, discount: true });
                            }}
                            className="btn-info button"
                          >
                            <LocalOfferOutlined />
                            Discount
                            <span>[ F2 ]</span>
                          </span>
                          <BasicDialog
                            title="Discount"
                            open={open.discount}
                            setOpen={(val) => {
                              setOpen({ ...open, discount: false });
                            }}
                          >
                            <div className="flex mb">
                              <TextField
                                variant="standard"
                                fullWidth
                                label="Bill Total"
                                disabled
                                value={currency(subTotalAmount)}
                              />
                            </div>
                            <div className="flex">
                              <div className=" col-6">
                                <NumFormat
                                  label="Percentage %"
                                  variant="outlined"
                                  autoFocus
                                  // onFocus={handleFocus}
                                  fullWidth
                                  value={values.discountPercentage}
                                  onChange={(e) =>
                                    setFieldValue(
                                      "discountPercentage",
                                      e.target.value
                                    )
                                  }
                                />
                              </div>

                              <div className=" col-6">

                                <NumFormat
                                  label="Money Rs."
                                  fullWidth
                                  variant="outlined"
                                  // onFocus={handleFocus}
                                  value={values.discountAmount}
                                  onChange={(e) =>
                                    setFieldValue(
                                      "discountAmount",
                                      e.target.value
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="flex-end">
                              <Button
                                color="secondary"
                                onClick={() => {
                                  setOpen({ ...open, discount: false });
                                }}
                              >
                                Apply
                              </Button>
                              <Button
                                color="inherit"

                                onClick={() => {
                                  setFieldValue(
                                    "discountAmount",
                                    0
                                  )
                                  setFieldValue(
                                    "discountPercentage",
                                    0
                                  )
                                  setOpen({ ...open, discount: false });
                                }}
                              >
                                Reset
                              </Button>
                            </div>
                          </BasicDialog>
                        </Grid>
                        <Grid item xs={4}>
                          <span
                            className="btn-info button"
                            onClick={() => setOpen({ ...open, return: true })}
                          >
                            <AssignmentReturnOutlined />
                            Return
                            <span>[ F4 ]</span>
                          </span>
                          <Dialog
                            open={open.return}
                            setOpen={(val) => {
                              setOpen({ ...open, return: val });
                            }}
                            title="Sales Return"
                            maxWidth="md"
                          >
                            <SalesReturn
                              setOpen={(val) => {
                                setOpen({ ...open, return: val });
                              }}
                            />
                          </Dialog>
                        </Grid>
                        <Grid item xs={4}>
                          {!invoiceValue.code &&
                            <span
                              className="btn-success button"
                              onClick={() =>
                                values.customer?.code == CUSTOMER_CONST.CASH_CUSTOMER ? alert(`"CASH": Customer Partial Payment Not Applicable`) :
                                setOpen({ ...open, payment: true })
                              }
                            >
                              <SaveOutlined />
                              Payment
                              <span>[ Alt + p ]</span>
                            </span>
                          }
                          <Dialog
                            open={open.payment}
                            setOpen={(val) => {
                              setOpen({ ...open, payment: val });
                            }}
                            title="Payment Receipt"
                            maxWidth="sm"
                          >
                            <Payments
                              billTotal={totalAmount}
                              isValid={cashPaymentValidity}
                              onSubmit={handleMorePayments}
                              setPrintType={setPrintType}
                            />
                          </Dialog>
                        </Grid>
                      </Grid>
                      <Grid container spacing={1} marginBottom={1}>
                        <Grid item xs={6}>
                          <span
                            className="btn-info button"
                            onClick={() => {
                              setOpen({ ...open, addCustomer: true });
                            }}
                          >
                            <GroupAddOutlined />
                            add Customer
                            <span>[ Alt + c ]</span>
                          </span>
                          <Dialog
                            maxWidth="md"
                            open={open.addCustomer}
                            setOpen={(val) => {
                              setOpen({ ...open, addCustomer: val });
                            }}
                            title={`Add Customer`}
                          >
                            <AddCustomer
                              setOpen={(val) => {
                                setOpen({ ...open, addCustomer: val });
                              }}
                            />
                          </Dialog>
                        </Grid>
                        <Grid item xs={6}>
                          <span
                            className="btn-info button"
                            onClick={() => {
                              setOpen({ ...open, salesOrder: true });
                            }}
                          >
                            <ReceiptOutlined />
                            Sales order
                            <span>[ Alt + o ]</span>
                          </span>
                          <Dialog
                            maxWidth="md"
                            open={open.salesOrder}
                            setOpen={(val) => {
                              setOpen({ ...open, salesOrder: val });
                            }}
                            title="Sales order"
                          >
                            <SalesOrder />
                          </Dialog>
                        </Grid>
                      </Grid>
                    </>
                  ) : (
                    <Grid container mt={1} mb={1} spacing={1}>
                     

                      <Grid item xs={12}>
                        <span
                          className="btn-success button"
                          //onClick={(handlePrint())}

                          onClick={() => {
                            handlePrintDotMatrix();
                          }}
                        >

                          <ReceiptOutlined />
                          RE PRINT - Bill
                          <span></span>
                        </span>
                      </Grid>
                      <Grid item xs={6}>
                        <button
                          style={{ height: "100%" }}
                          type="button"
                          className="btn-info button"
                          onClick={() => {
                            if (invoiceValue.paidStatus != PAYMENT_STATUS_CODE.PAYMENT_NOT_DONE)
                              alert("Cannot edit partial payment or fully payment");
                            else {
                              setPageStatus({
                                ...pageStatus,
                                editable: true,
                                recalled: false
                              });
                            }
                          }}
                        >
                          <EditIcon />
                          Edit
                          <span style={{ marginTop: 5 }}>[ Alt + E ]</span>
                        </button>
                      </Grid>
                      <Grid item xs={6}>
                        <span
                          className="btn-danger button"
                          onClick={() => {
                            setInvoiceValue(initInvoice);
                            setPageStatus({
                              ...pageStatus,
                              editable: false,
                              recalled: false,
                              adding: true
                            });
                          }}
                        >
                          <CloseIcon />
                          Close
                          <span>...</span>
                        </span>
                      </Grid>
                    </Grid>
                  )}
                  <div style={{ display: "none" }}>
                    {submittedData &&
                      <>
                        <Print
                          ref={computerReceiptPrintComponent}
                          submittedData={submittedData}
                          paymentTypes={paymentTypes}
                          pageStatus={pageStatus} />

                        {/* <PrintBill
                          ref={billReceiptPrintComponent}
                          submittedData={submittedData}
                          pageStatus={pageStatus}
                          paymentTypes={paymentTypes} /> */}
                      </>
                    }
                  </div>
                </Paper>
                <RecentSales
                  data={lastThreeInvoice}
                  fetchRecentInvoice={fetchRecentInvoice}
                  invoiceRecall={recallPrevInvoice}
                />
              </Grid>
            </Grid>
          </Form>
        );
      }}
    </Formik >
  );
};

export default SalesForAutoCare;